/* eslint-disable react/no-unescaped-entities */
import React from "react";

import { Grid } from "@mui/material";

import { Wrapper, Title, DescriptionContainer, Description, TitleContainer } from "./styles";

const defaultIcon = require("Assets/img/no-gps.svg");

type InvoiceEmptySectionProps = {
  title?: string;
  description?: string;
  isCreate?: boolean;
};

export const TrackingEmptySection = ({
  title,
  description,
  isCreate = false,
}: InvoiceEmptySectionProps) => {
  return (
    <Wrapper
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      data-cy="invoice-maintenance-empty"
    >
      <Grid item xs={12}>
        <img src={defaultIcon} alt="empty state" />
      </Grid>
      <Grid container direction="column" alignItems="center" justifyContent="center" spacing={2}>
        <TitleContainer item xs={4}>
          <Title>{title}</Title>
        </TitleContainer>
        <DescriptionContainer item>
          <Description notInfo={isCreate}>{description}</Description>
        </DescriptionContainer>
      </Grid>
    </Wrapper>
  );
};
